import React from 'react';
import { ArrowUpRight, MapPin, Mail, Phone } from 'lucide-react';
import { Link } from './Router';
import { Logo } from './Logo';

interface FooterProps {
  onOpenImpressum: () => void;
  onOpenPrivacy: () => void;
  onOpenAdmin: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onOpenImpressum, onOpenPrivacy, onOpenAdmin }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-10 pb-6 border-t border-gray-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-orange/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* GRID LINKS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8 mb-8">
           
           {/* Column 1: Logo & Kontakt */}
           <div className="space-y-6">
              <div className="mb-4">
                <Logo variant="white" className="h-6" /> 
              </div>
              
              <div className="flex items-start gap-3">
                 <MapPin className="text-gray-600 mt-1 flex-shrink-0" size={16} />
                 <address className="not-italic text-gray-400 font-medium leading-relaxed text-sm">
                    Bethesna Verwaltung GmbH<br/>
                    Lankwitzer Straße 9<br/>
                    12107 Berlin
                 </address>
              </div>

              <ul className="space-y-2">
                 <li>
                    <a href="mailto:info@zackig.marketing" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group">
                       <Mail className="text-gray-600 group-hover:text-brand-orange transition-colors" size={16} />
                       <span className="font-bold text-sm">info@zackig.marketing</span>
                    </a>
                 </li>
                 <li>
                    <a href="tel:+491731898804" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group">
                       <Phone className="text-gray-600 group-hover:text-brand-orange transition-colors" size={16} />
                       <span className="font-bold text-sm">+49 173 189 88 04</span>
                    </a>
                 </li>
              </ul>
           </div>

           {/* Column 2: Navigation */}
           <div>
              <h4 className="text-brand-orange font-bold uppercase tracking-widest text-[10px] mb-6">Navigation</h4>
              <ul className="space-y-2 text-sm">
                 <li><Link to="/leistungen" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300">Leistungen</Link></li>
                 <li><Link to="/cases" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300">Success Stories</Link></li>
                 <li><Link to="/prozess" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300">Der Prozess</Link></li>
                 <li><Link to="/team" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300">Team & Jobs</Link></li>
              </ul>
           </div>

           {/* Column 3: Rechtliches & V-Cards */}
           <div>
              <h4 className="text-brand-orange font-bold uppercase tracking-widest text-[10px] mb-6">Rechtliches</h4>
              <ul className="space-y-2 text-sm">
                 <li><button onClick={onOpenImpressum} className="text-gray-400 hover:text-white transition-colors font-medium text-left">Impressum</button></li>
                 <li><button onClick={onOpenPrivacy} className="text-gray-400 hover:text-white transition-colors font-medium text-left">Datenschutz</button></li>
              </ul>

              <h4 className="text-brand-orange font-bold uppercase tracking-widest text-[10px] mt-6 mb-3">Digitale Visitenkarten</h4>
              <ul className="space-y-2 text-sm">
                 <li><Link to="/edin" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300 flex items-center gap-2">Edin <ArrowUpRight size={12} className="opacity-50" /></Link></li>
                 <li><Link to="/arne" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300 flex items-center gap-2">Arne <ArrowUpRight size={12} className="opacity-50" /></Link></li>
                 <li><Link to="/hakan" className="text-gray-400 hover:text-white transition-colors font-medium block hover:translate-x-1 duration-300 flex items-center gap-2">Hakan <ArrowUpRight size={12} className="opacity-50" /></Link></li>
              </ul>

              <div className="pt-6">
                <button onClick={onOpenAdmin} className="text-gray-800 hover:text-gray-600 transition-colors font-bold text-[10px] uppercase flex items-center gap-2">
                   Internal Login
                </button>
              </div>
           </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-6 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center gap-4">
           <p className="text-gray-600 text-[10px] font-medium">
              &copy; {currentYear} Bethesna Verwaltung GmbH.
           </p>
           <p className="text-gray-600 text-[10px] font-bold uppercase tracking-wider flex items-center gap-2">
              Made in Berlin <span className="w-1 h-1 rounded-full bg-brand-orange"></span> Berlin City West
           </p>
        </div>

      </div>
    </footer>
  );
};